window.postMessageHandler = function postMessageHandler(event) {
  const whitelist = [
    '.rad.localdev',
    '.rad1.localdev',
    '.lightspeedappdev.com',
    '.lightspeedappstaging.com',
    '.lightspeedappstg.com',
    '.lightspeedapp.com',
    '.merchantos.com',
  ];

  function isDomainWhitelisted(domain: TSFixMe) {
    return whitelist.some(d => domain.indexOf(d) >= 0);
  }

  if (!isDomainWhitelisted(event.origin)) {
    return;
  }
  if (
    typeof event.data === 'object' &&
    !!event.data.type &&
    typeof event.data.payload === 'object'
  ) {
    switch (event.data.type) {
      case 'pageRouterGoTo':
        window.PageRouter.goTo(event.data.payload.url);
        break;
      case 'navigateToContent':
        window.navigateToContent(
          event.data.payload.type,
          event.data.payload.name,
          event.data.payload.params
        );
        break;
      case 'openUrl':
        window.merchantos.utils.openUrl(event.data.payload.url, event.data.payload.target);
        break;
      case 'routeChange':
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
        history.replaceState(null, null, event.data.payload.url);
        break;
      case 'updateBreadcrumbs':
        window.merchantos.asyncSubscribe.notifySubscribers('react.mount.topbar', {
          props: {
            crumbs: event.data.payload.crumbs,
          },
        });
        break;
      case 'notification':
        window.flashNotifier(
          event.data.payload.type,
          event.data.payload.message,
          event.data.payload.seconds
        );
        break;
      case 'updateDocumentTitle':
        window.document.title = event.data.payload.title;
        break;
      default:
        break;
    }
  }
};

if (window.addEventListener) {
  window.addEventListener('message', window.postMessageHandler, false);
}
